export const reduceSeriesToValue = (data, days, metric) =>
  data
    .map(d => d[metric])
    .slice(-days)
    .reduce((a, b) => a + b, 0)

export const reduceSeriesToValuePreviousPeriod = (data, days, metric) =>
  data
    .map(d => d[metric])
    .slice(-days * 2, -days)
    .reduce((a, b) => a + b, 0)

export const computeChangeThisPeriod = (data, days, metric) =>
  calculateChangeRate(
    reduceSeriesToValue(data, days, metric),
    reduceSeriesToValuePreviousPeriod(data, days, metric)
  )

export const TimePeriods = Object.freeze({
  last_07_days: {
    days: 7,
    metric: "last_07_days",
    description: "in the last 7 days",
  },
  last_30_days: {
    days: 30,
    metric: "last_30_days",
    description: "in the last 30 days",
  },
  last_90_days: {
    days: 90,
    metric: "last_90_days",
    description: "in the last 90 days",
  },
})

export const parseStat = (data, comparison, timePeriod, metricShortName) =>
  (data[comparison] &&
    data[comparison][0][
      `${metricShortName}_${TimePeriods[timePeriod].metric}`
    ]) ||
  0

export const parseChange = (data, timePeriod, metricShortName) =>
  calculateChangeRate(
    parseStat(data, "current", timePeriod, metricShortName),
    parseStat(data, "comparison", timePeriod, metricShortName)
  )

export const calculateChangeRate = (newData, oldData) => {
  if (newData === 0 && oldData === 0) {
    return 0
  } else {
    return (newData - oldData) / oldData
  }
}

export const fixedPercentValue = (numerator, denominator) => {
  let value
  if (!denominator) {
    value = numerator * 100
  } else {
    value = (numerator / denominator) * 100
  }
  return value.toFixed(value > 1 ? 0 : 1)
}
